import {Avatar, Badge, Drawer, Spin} from "antd";
import "./master.css";
import React, {useEffect, useRef, useState} from "react";


import {Link, Navigate, useLocation, useNavigate} from "react-router-dom";


import useOutsideClick from "@/hook/useOutSideClick";
import {useLayout} from "@/hook/useLayout";
import {useAuth} from "@/provider/AuthProvider";
import {myAcademy} from "@/lib/services/academyService";
import {URLS} from "@/lib/urls";
import RenderIf from "@/components/render-if";
import {ArrowRight} from "lucide-react";
import {Can} from "@/components/can/Can";
import ThemeToggle from "@/components/toggle-theme/ToggleTheme";


export function MasterLayout(
    {
        sidebarMenu,
        pageTitle,
        userMenu,
        sidebarFooterMenu,
        children,
        module,
        backTo,
        pageLoading = false,
    }) {

    const {openNavigation, setOpenNavigation} = useLayout();
    const [userOverlay, setUserOverlay] = useState(false)
    const overlayRef = useRef(null);
    useOutsideClick(overlayRef, () => setUserOverlay(false));
    const navigate = useNavigate();
    const {user, logout, academy, dashboard} = useAuth();


    const [open, setOpen] = useState(false);
    const [selectedAcademy, setSelectedAcademy] = useState();
    const [menus, setMenus] = useState(sidebarMenu ?? [])

    useEffect(() => {
        if (sidebarMenu) {
            setMenus(sidebarMenu);
        }
    }, [sidebarMenu]);


    useEffect(() => {
        const lockedOnAcademy = myAcademy();
        setSelectedAcademy(lockedOnAcademy);
    }, [academy]);


    useEffect(() => {
        if (!user) return (<Navigate to={URLS.auth.login}/>)
    }, [user]);


    const logoutUser = async (e) => {
        logout();
    }


    const onClose = () => {
        setOpen(false);
    };

    return (<>
        <Drawer

            placement="right"
            closable={false}
            onClose={onClose}
            open={open}
            width={260}
            styles={{
                body: {
                    padding: 0,
                    height: "100%"
                },
            }}
            key={"right"}
        >
            <div className={`h-full`}>
                <SidebarWidget menuItems={menus} sidebarFooterMenu={sidebarFooterMenu}/>
            </div>
        </Drawer>
        <div className="flex h-lvh relative">
            <div className={`hidden md:flex`}>
                <SidebarWidget menuItems={menus} sidebarFooterMenu={sidebarFooterMenu}/>
            </div>
            <div className="w-full flex flex-col overflow-hidden">
                <div
                    className="h-[58px] w-full border-b dark:border-gray-600 flex items-center px-4 justify-between bg-white dark:bg-gray-900  ">
                    <div className="h-[58px] flex items-center gap-2 ">
                        <i className={`icon-bars text-xl md:hidden cursor-pointer`} onClick={() => setOpen(true)}></i>
                        <RenderIf condition={backTo}>
                            <RenderIf condition={backTo === true} falsyElement={<Link to={backTo} title={'بازگشت'}>
                                <ArrowRight/>
                            </Link>}>
                                <div onClick={() => {
                                    navigate(-1)
                                }}>
                                    <ArrowRight/>
                                </div>
                            </RenderIf>

                        </RenderIf>
                        <span className="font-semibold">
                            {pageTitle ?? academy?.name}
                        </span>

                    </div>

                    <div className={`flex justify-end items-center`}>
                        <div className={'hidden md:flex'}>
                            <NotificationBadge count={dashboard?.notifications_count} module={module}/>
                            <ThemeToggle />
                        </div>
                        <div className="relative ">
                            <div className="pr-4 flex cursor-pointer items-center" onClick={() => setUserOverlay(true)}>
                                <Avatar shape="circle"
                                        icon={<img src={user?.useracademy?.avatar ?? `/images/profile.jpg`}
                                                   alt="profile"/>}/>
                                <div className="pr-2 flex flex-col  overflow-hidden">
                                    <span
                                        className="hidden md:flex text-wrap	text-sm font-medium  max-w-32 truncate line-clamp-1"
                                        title={user?.useracademy?.firstname}>
                                        <b>{user?.useracademy?.firstname} {' '} {user?.useracademy?.lastname}</b>
                                    </span>
                                    <span
                                        className="hidden md:flex text-xs  text-wrap break-words md:max-w-xl overflow-hidden">
                                        {user?.mobile}
                                    </span>

                                </div>
                            </div>
                            <div ref={overlayRef}
                                 className={`${userOverlay ? "absolute" : "hidden"} z-50 shadow-2xl p-3 flex flex-col w-56 left-0 top-10 bg-white dark:bg-gray-800 rounded  border border-gray-4 dark:border-gray-600`}>
                                <div className={'flex flex-col md:hidden'}>
                                     <span
                                         className=" text-wrap	text-sm font-medium  max-w-32 truncate line-clamp-1"
                                         title={user?.useracademy?.firstname}>
                                        <b>{user?.useracademy?.firstname} {' '} {user?.useracademy?.lastname}</b>
                                    </span>
                                    <span
                                        className=" text-xs  text-wrap break-words md:max-w-xl overflow-hidden">
                                        {user?.mobile}
                                    </span>
                                    <div className="w-full h-[1px] bg-gray-400 dark:bg-gray-700 my-2"></div>
                                </div>
                                <div className={'flex flex-col md:hidden'}>
                                    <div className="flex text-sm items-center gap-1">
                                        <NotificationBadge count={dashboard?.notifications_count} module={module}/>
                                        صندوق پیام
                                    </div>

                                    <div className="w-full h-[1px] bg-gray-400 dark:bg-gray-700 my-2"></div>
                                </div>

                                <ThemeToggle withName={true} />
                                <Link className="flex items-center gap-2 cursor-pointer" to={URLS.gateway.selector}>
                                    <i className="icon-network-wired "></i>
                                    <span className=" text-sm ">انتخاب نقش</span>
                                </Link>
                                {userMenu}
                                <div className="w-full h-[1px] bg-gray-400 dark:bg-gray-700 my-2"></div>
                                <div className="flex items-center gap-2 cursor-pointer" onClick={logoutUser}>
                                    <i className="icon-door-closed "></i>
                                    <span className=" text-sm ">
                                        خروج از حساب کاربری
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="h-0.5 w-full bg-gradient-to-r from-transparent via-cyan-400 to-transparent" ></div>

                <div className="flex flex-col h-full overflow-auto relative p-2">
                    <RenderIf condition={pageLoading}>
                        <Spin spinning={true} size={'large'}/>
                    </RenderIf>
                    <RenderIf condition={!pageLoading}>
                        {children}
                    </RenderIf>

                </div>

            </div>
            <div onClick={() => setOpenNavigation(!openNavigation)}
                 className={`transition-all hidden md:flex duration-300 bg-white dark:bg-gray-700 border dark:border-gray-500 w-[30px] h-[32px] absolute ${openNavigation ? "right-[244px]" : "right-[44px]"} z-50 bottom-4 rounded-full flex items-center justify-center cursor-pointer`}>
                <i className={`icon-chevron-left transition-all duration-400  ${openNavigation ? "rotate-180" : "left"}`}></i>
            </div>

        </div>
    </>)
}


export const SidebarItemWidget = ({item}) => {
    const location = useLocation();
    const {openNavigation} = useLayout();
    const [openItem, setOpenItem] = useState(location.pathname.startsWith(item.path));
    const navigate = useNavigate();
    const {groupPrefix} = useAuth();

    return (
        <div className={`transition-all duration-500`}>
            <RenderIf condition={item?.children}>
                <Can permission={item?.can ?? null}>
                    <div
                        className={`sideBarItem ${(location.pathname === item.path) && "sideBarItem--active"} justify-between`}
                        onClick={() => {
                            if (item.children) {
                                setOpenItem(!openItem);
                            } else {
                                navigate(item.path);
                            }
                        }}>

                        <div className={`flex items-center justify-center gap-2`}>
                            <i className={`${item.icon} ${openNavigation ? "" : "mr-[4px]"} text-[15px] `}></i>
                            <span
                                className={`${!openNavigation && "hidden"}`}>{item.name}</span>
                        </div>
                        {item.children &&
                            <i className={`icon-chevron-down ${openItem && "rotate-180"} ${!openNavigation && "hidden"} text-[12px] `}></i>}
                    </div>
                </Can>

            </RenderIf>
            <RenderIf condition={!item?.children}>
                <Can permission={item?.can ?? null}>
                    <Link to={item.path}
                          className={`sideBarItem ${(location.pathname === item.path) && "sideBarItem--active"} justify-between`}
                    >
                        <div className={`flex items-center justify-center gap-2`}>
                            <i className={`${item.icon} ${openNavigation ? "" : "mr-[4px]"} text-[15px] `}></i>
                            <span
                                className={`${!openNavigation && "hidden"}`}>{item.name}</span>
                        </div>
                        {item.children &&
                            <i className={`icon-chevron-down ${openItem && "rotate-180"} ${!openNavigation && "hidden"} text-[12px] `}></i>}
                    </Link>
                </Can>

            </RenderIf>

            {(item.children && openNavigation) &&
                <div

                    className={` flex flex-col pr-4 ${!openItem ? "max-h-0 overflow-hidden" : "max-h-[2000px] "} transition-all`}>
                    {item.children.map((child, index) => (
                        <Can permission={child?.can ?? null} key={index + 'menu'}>
                            <Link to={`${child.path}`}
                                  className={`secondSideBarItem mr-4  ${`${item.path}${child.path}` === location.pathname && "sideBarItem--active"} `}>
                                <i className={`${child.icon} ${openNavigation ? "" : "mr-[3px]"}`}></i>
                                <span className={`${!openNavigation && "hidden"}`}>{child.name}</span>
                            </Link>
                        </Can>

                    ))}
                </div>
            }
        </div>
    )
}

export function SidebarWidget({menuItems, sidebarFooterMenu}) {
    const {openNavigation, setOpenNavigation} = useLayout();

    const {academy} = useAuth()

    return (
        <div
            className={`${openNavigation ? "w-[260px]" : "w-[50px]"} h-full  overflow-x-hidden border-l dark:border-gray-600
             overflow-y-auto transition-all duration-300 px-2 py-1 flex flex-col items-start
             bg-white dark:bg-gray-900 
             
              justify-between`}>
            <div className={`w-full`}>
                <div className={`flex cursor-pointer items-center mb-1 gap-2`}
                >
                    <Link to={`/`} className={'flex'}>
                        {academy?.logo && <div className={'min-w-[50px] min-h-[50px]'}>
                            <img src={academy?.logo}
                                 className="rounded-full h-[50px] w-[50px]" alt={academy?.name}/>
                        </div>}
                        {openNavigation && <div className={'mx-1 sm:hidden md:flex'}>

                            <span className={''}>{academy?.name}</span>
                        </div>}

                    </Link>

                </div>
                <div className={'mt-2'}>
                    {menuItems.map((item, index) => (
                        <SidebarItemWidget key={index} item={item}/>
                    ))}
                </div>

            </div>
            <div className={`w-full`}>
                {sidebarFooterMenu && <>
                    <div className="w-full h-[1px] my-2"></div>
                    {sidebarFooterMenu}
                </>}
            </div>
        </div>

    )
}


function NotificationBadge({count, module}) {
    const navigate = useNavigate();

    return (
        <>
            <Link to={URLS.notification[module]}>
                <Badge count={count} size="medium" className="mx-1">
                    <i className="icon-bell1 text-lg  hover:text-black cursor-pointer"></i>
                </Badge>

            </Link>
        </>
    );
}
